<template>
  <action-dispatcher
    action="article/getArticle"
    :parameters="$route.params.id"
    class="view-article"
  >
    <div class="container py-5">
      <div class="text-center mb-5">
        <div v-if="article.duration" class="font-serif">
          Leitura: {{ duration }}
        </div>
        <h1 class="text-primary">{{ article.title }}</h1>
        <p v-if="article.author" class="font-serif lead">
          {{ article.author.name }}
        </p>
      </div>
      <div class="embed-responsive embed-responsive-16by9">
        <img :src="article.cover" class="embed-responsive-item" />
      </div>
      <hr />
      <div class="small-container">
        <h5>RESUMO</h5>
        <div
          v-html="article.short_description"
          class="font-serif content"
        ></div>
      </div>
      <hr />

      <div
        v-if="article.content"
        v-html="article.content"
        class="small-container content"
      ></div>
      <topics v-else :topics="article.topics"></topics>

      <template v-if="article.notes || article.bibliography">
        <hr />
        <div class="small-container">
          <h5><i class="icon-book-open"></i> REFERÊNCIAS</h5>
          <template v-if="article.notes">
            <h5 class="mt-5 font-weight-medium">NOTAS</h5>
            <div v-html="article.notes"></div>
          </template>
          <template v-if="article.bibliography">
            <h5 class="mt-5 font-weight-medium">BIBLIOGRAFIA</h5>
            <div v-html="article.bibliography"></div>
          </template>
        </div>
      </template>
      <div v-if="article.author" class="author">
        <img :src="article.author.photo" class="img-fluid" />
        <div>
          <h4 class="mb-4">{{ article.author.name }}</h4>
          <div v-html="article.author.description"></div>
        </div>
      </div>
    </div>
  </action-dispatcher>
</template>

<script>
import { mapState } from "vuex";
import Topics from "../components/article/Topics";

export default {
  components: { Topics },
  computed: {
    ...mapState("article", ["article"]),
    duration() {
      if (!this.article.duration) return "0min";
      const duration = this.article.duration.split(":");
      if (duration[0] > 0) {
        return `${duration[0]}h ${duration[1]}min`;
      } else {
        return `${duration[1]}min`;
      }
    }
  }
};
</script>

<style lang="scss">
.view-article {
  h1 {
    font-size: 40px;

    @media screen and (max-width: 768px) {
      font-size: 30px;
    }
  }
  .container {
    max-width: 1100px;
  }

  .small-container {
    max-width: 900px;
    margin: 0 auto;
  }

  .content {
    font-size: 18px;

    p {
      font-family: "miller-text", serif;
      margin: 24px 0;
    }

    h1,
    h2,
    h3,
    h4,
    h5 {
      margin: 48px 0;
      text-transform: uppercase;
      font-weight: bold;
    }

    blockquote {
      border-left: 4px solid #f16336;
      padding-left: 36px;
      font-style: italic;
    }

    > p:first-of-type::first-letter {
      -webkit-initial-letter: 2;
      initial-letter: 2;
      margin-right: 8px;
    }

    iframe {
      max-width: 100%;
    }
  }

  hr {
    background: #a9a395;
    margin: 48px 0;
    width: 100%;
  }

  .author {
    display: flex;
    gap: 24px;
    padding: 24px;
    border: 1px solid #191919;

    img {
      max-width: 140px;
      max-height: 140px;
      min-width: 140px;
      min-height: 140px;
      object-fit: cover;
    }
  }
}
</style>
